
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[shortlink]",
      function () {
        return require("private-next-pages/[shortlink].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[shortlink]"])
      });
    }
  